export default __webpack_public_path__ + "static/media/Tou-ring.905dd10d.png";